export const outofscopeConstants = {
    OUTOFSCOPE_SAVE_REQUEST: 'OUTOFSCOPE_SAVE_REQUEST',
    OUTOFSCOPE_SAVE_SUCCESS: 'OUTOFSCOPE_SAVE_SUCCESS',
    OUTOFSCOPE_SAVE_FAILURE: 'OUTOFSCOPE_SAVE_FAILURE',
    OUTOFSCOPE_SAVE_CLEAR: 'OUTOFSCOPE_SAVE_CLEAR',
};